import { useTypedParams } from "react-router-typesafe-routes";
import { useCallback, useState } from "react";

import { TableColumnSettingsProvider } from "@providers/TableColumnSettingsProvider/TableColumnSettingsProvider";

import { ApplicationSharedCredentialsTable } from "@components/Tables/ApplicationSharedCredentialsTable/ApplicationSharedCredentialsTable";

import { Box } from "@design-system/Box/Box";
import { Search } from "@design-system/Search/Search";

import { PortalHeaderActions } from "@layouts/PortalPage/PortalHeaderActions";

import { routes } from "@pages/routes";

const defaultColumnSettings = {
  name: true,
  credential: true,
  lastUsed: true,
};
const defaultColumnOrder = ["name", "credential", "lastUsed"];

export const ApplicationSharedCredentials = () => {
  const { clientId, applicationId } = useTypedParams(
    routes.portal.clients.client.applications.application.sharedCredentials,
  );
  
  const [search, setSearch] = useState("");

  const handleSearchChange = useCallback((value: string) => {
    setSearch(value);
  }, []);

  return (
    <TableColumnSettingsProvider
      tableId="application-shared-credentials"
      defaultColumnSettings={defaultColumnSettings}
      defaultColumnOrder={defaultColumnOrder}
    >
      <Box direction="column" fullStretch>
        <PortalHeaderActions>
        <Box direction="row" gap={8} align="center">
          <div style={{ width: 300 }}>
            <Search onChange={handleSearchChange} />
          </div>
        </Box>
        </PortalHeaderActions>
        <ApplicationSharedCredentialsTable
          clientId={clientId}
          clientApplicationId={applicationId}
          search={search}
        />
      </Box>
    </TableColumnSettingsProvider>
  );
};